import React, { JSX, useEffect, useRef, useState } from 'react';
import { classNames } from 'assets/utils/helper';
import { ClinicalTrialSort } from 'lib/clinical-trials/types';

type ClinicalTrialsSortByProps = {
  sort: ClinicalTrialSort;
  updateSort: (sort: ClinicalTrialSort) => void;
};

const optionsMap: Array<{ value: ClinicalTrialSort; label: string }> = [
  { value: 'BEST_MATCH', label: 'Best Match' },
  { value: 'NEWEST', label: 'Newest' },
  { value: 'ALPHABETICAL', label: 'Alphabetically (A-Z)' },
  { value: 'REVERSE_ALPHABETICAL', label: 'Alphabetically (Z-A)' },
];

const ClinicalTrialsSortBy = (
  props: ClinicalTrialsSortByProps
): JSX.Element => {
  const { sort, updateSort } = props;
  const [sortActive, setSortActive] = useState(false);
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (container.current && !container.current.contains(e.target as Node)) {
        setSortActive(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="sort-box clinical-trials-sort" ref={container}>
      <button
        type="button"
        onClick={() => setSortActive(!sortActive)}
        className={classNames(
          'btn-tertiary sort-btn',
          sortActive ? 'open' : ''
        )}
      >
        Sort Results by:{' '}
        {optionsMap.find(option => option.value === sort)?.label}
      </button>
      {sortActive && (
        <div className="sort-dropdown">
          {optionsMap.map(option => (
            <div className="radio-wrapper" key={option.value}>
              <input
                onChange={() => {
                  updateSort(option.value);
                  setSortActive(false);
                }}
                type="radio"
                id={`ct-sort-${option.value}`}
                checked={sort === option.value}
                name="ClinicalTrialsSort"
              />
              <label htmlFor={`ct-sort-${option.value}`}>
                <span>{option.label}</span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClinicalTrialsSortBy;
